import React from 'react';
import '../../css/roadMap.css'; // Ensure this path is correct for your project structure

const RoadMap = ({ data }) => {
    return (
        <div className="road-map-container">
            <h2 className="main-title">{data.title}</h2>
            <div className="road-map-steps">
                {data.map?.map((step, index) => (
                    <div key={step.id} className="road-map-step">
                        <div className="road-map-node">
                            <span className="node-number">{index + 1}</span> {/* Number inside the circle */}
                        </div>
                        <div className="node-content">
                            <div className="node-title">{step.title}</div>
                            <div className="node-desc">{step.shortDesc}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default RoadMap;
